const structure = [
    {
        title: "Modelo de vivienda",
        multiSelect : false,
        elements: ["Suite", "Suite Line","Suite Plus", "Suite Z", "Suite Doble","Suite U"],
        prices: ["3€", "6€", "9€", "12€", "15€","18€"],
        meshes: ["suite.glb", "suite-line.glb", "suite-plus.glb", "suite-z.glb", "suite-doble.glb","suite-u.glb"],
        previewTextures: ["suite-preview.jpg", "line-preview.jpg", "plus-preview.jpg", "z-preview.jpg", "doble-preview.jpg","u-preview.jpg"],
        default: 5
    },
    {
        title: "Cubierta",
        multiSelect : false,
        elements: ["Plano Grava", "Plano Vegetal", "Dos Aguas Teja", "Dos Aguas Chapa Gris", "Dos Aguas Chapa Rojo"],
        prices: ["3€", "6€", "3€", "6€"],
        meshNames: ["techo-grava", "techo-hierba", "techo-teja", "techo-chapa", "techo-chapa-roja"],
        previewTextures: ["grava-preview.jpg", "hierba-preview.jpg", "teja-preview.jpg", "techo-chapa-preview.jpg", "techo-chapa-roja-preview.jpg"],
        disclaimer : "* Consultar disponibilidad de otros colores.",
        default: 0
    },
    {
        title: "Materiales de exterior",
        multiSelect : false,
        elements: ["Porcelanico Antracita", "Porcelanico Gris", "Porcelanico Arena", "Madera Roble Vintage", "Madera Wengue", "Chapa Gris Antracita", "Chapa Blanco Grisáceo", "Chapa Verde Reseda"],
        prices: ["3€", "6€", "4€", "6€", "4€"],
        meshNames: ["acabado-porcelanico", "acabado-porcelanico", "acabado-porcelanico", "acabado-madera", "acabado-madera", "acabado-chapa", "acabado-chapa", "acabado-chapa"],
        previewTextures: ["antracita-preview.jpg", "gris-preview.jpg", "arena-preview.jpg", "madera-preview.jpg", "wengue-preview.jpg", "chapa-gris-preview.jpg", "chapa-blanco-preview.jpg", "chapa-verde-preview.jpg"],
        materials: ["antracita-baked", "gris-baked", "arena-baked", "wood-baked", "wengue-baked", "grey-metal-baked", "white-metal-baked", "green-metal-baked"],
        disclaimer : "* Consultar disponibilidad de otros colores.",
        default: 1
    },
    {
        title: "Materiales de interior",
        multiSelect : false,
        elements: [ "Roble Eyre Gris", "Roble Vera Homeaje",  "Roble Vera Siglo", "Porcelanico Gris", "Porcelanico Antracita", "Porcelanico Arena",],
        prices: ["3€", "6€", "4€", "6€", "4€", "6€"],
        previewTextures: ["eyre-preview.jpg", "vera-preview.jpg", "siglo-preview.jpg", "gris-preview.jpg", "antracita-preview.jpg", "arena-preview.jpg"],
        materials: ["floor-eyre", "floor-vera", "floor-siglo", "floor-gris", "floor-antracita", "floor-arena"],
        disclaimer : "* Consultar disponibilidad de otros colores.",
        default: 0
    },
    {
        title: "Extras",
        multiSelect : true,
        elements: ["Descanso saludable", "Armarios", "Instalación fotovoltaica", "Instalación domótica", "Iluminación saludable"],
        previewTextures: ["descanso-preview.jpg", "armarios-preview.jpg", "fotovoltaica-preview.jpg", "domotica-preview.jpg", "iluminacion-preview.jpg"],
        prices: ["3€", "6€", "9€", "12€", "15€"],
        default: "none"
    },
];
export default structure;